import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ThemeProvider } from './hooks/useTheme';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { CustomCursor } from './components/CustomCursor';
import { LoadingScreen } from './components/LoadingScreen';
import { Favicon } from './components/Favicon';
import { PageTransition } from './components/PageTransition';
import { WhatsAppButton } from './components/WhatsAppButton';
import { BookingProvider } from './components/BookingModal';
import { MorvixConsultant } from './components/MorvixConsultant';
import { Home } from './pages/Home';
import { ServicesPage } from './pages/ServicesPage';
import { WorkPage } from './pages/WorkPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0" data-mp="3mjg8pi0yg3km">
      <Routes location={location} key={location.pathname} data-id="element-1" data-mp="3rbrakqf99zft">
        <Route path="/" element={<PageTransition data-id="element-3" data-mp="4wv3njt0sf7">
              <Home data-id="element-4" data-mp="56n1goet9nj" />
            </PageTransition>} data-id="element-2" data-mp="3recd7hndojem" />
        <Route path="/services" element={<PageTransition data-id="element-6" data-mp="33moqzd129wio">
              <ServicesPage data-id="element-7" data-mp="33nq6btp41567" />
            </PageTransition>} data-id="element-5" data-mp="2zm4zaoz9bl3x" />
        <Route path="/work" element={<PageTransition data-id="element-9" data-mp="38nuorp9kw9z2">
              <WorkPage data-id="element-10" data-mp="3dkl42adk71jf" />
            </PageTransition>} data-id="element-8" data-mp="38m1jadapbvsn" />
        <Route path="/about" element={<PageTransition data-id="element-12" data-mp="nuhj4kutefvc">
              <AboutPage data-id="element-13" data-mp="nvan5e2e2r9s" />
            </PageTransition>} data-id="element-11" data-mp="3dirw8rr7mb9u" />
        <Route path="/contact" element={<PageTransition data-id="element-15" data-mp="3688rpx40wyp">
              <ContactPage data-id="element-16" data-mp="356tf9929ob6" />
            </PageTransition>} data-id="element-14" data-mp="stc7e2bjwwmu" />
        <Route path="*" element={<PageTransition data-id="element-18" data-mp="3uevq7us8c00z">
              <Home data-id="element-19" data-mp="d4e57s05daw6" />
            </PageTransition>} data-id="element-17" data-mp="3udaxmaph6r5r" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <ThemeProvider data-id="element-20" data-mp="864b7kq5sgc5">
      <BrowserRouter data-id="element-21" data-mp="83i23gnmdsrt">
        <BookingProvider data-id="element-22" data-mp="3gleakl2nz7g8">
        <div className="flex min-h-screen w-full flex-col bg-surface text-ink" data-id="element-23" data-mp="3gklbm69y5m8n">
          <Favicon data-id="element-24" data-mp="3bmjrrj4p5iw4" />
          <LoadingScreen data-id="element-25" data-mp="3bn30qacdcwy0" />
          <CustomCursor data-id="element-26" data-mp="3bnuvxk220snr" />
          <ScrollToTop data-id="element-27" data-mp="3bkgss9lkgff9" />
          <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[110] focus:bg-brand focus:px-4 focus:py-2 focus:text-sm focus:text-white" data-id="element-28" data-mp="3qbpo8zc5gv0b">
            Skip to content
          </a>
          <Navbar data-id="element-29" data-mp="2xssebznuhev4" />
          <main id="main" className="flex-1" data-id="element-30" data-mp="2svtmxovkfm0m">
            <AnimatedRoutes data-id="element-31" data-mp="2sv0r3iy5agx9" />
          </main>
          <Footer data-id="element-32" data-mp="18drjdvxkvfdt" />
          <WhatsAppButton data-id="element-33" data-mp="18d9ekawunsua" />
          <MorvixConsultant data-id="element-34" data-mp="18czlufkf77kw" />
        </div>
        </BookingProvider>
      </BrowserRouter>
    </ThemeProvider>;
}